import { useState } from "react";
import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader,
  AlertDialogFooter, AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// Community "The Floor" — founder go-live hardening (2026-02). One shared, reusable
// destructive-action confirm dialog for every hard-delete in this module (individual post/
// comment delete AND the founder-only bulk-clear) — no delete anywhere in the app previously
// had ANY confirm step at all, this closes that gap in one place instead of N ad-hoc ones.
// `requirePhrase` (bulk-clear only) makes the Confirm button stay disabled until the typed
// text matches exactly — a plain Yes/No (post/comment delete) just needs `requirePhrase` unset.
export function ConfirmDialog({ trigger, title, description, confirmLabel = "Delete", requirePhrase = null, onConfirm, testIdPrefix }) {
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const canConfirm = !requirePhrase || typed.trim() === requirePhrase;

  return (
    <AlertDialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setTyped(""); }}>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent data-testid={`${testIdPrefix}-confirm-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={`${testIdPrefix}-confirm-title`}>{title}</AlertDialogTitle>
          <AlertDialogDescription data-testid={`${testIdPrefix}-confirm-description`}>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {requirePhrase && (
          <input
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={requirePhrase}
            autoComplete="off"
            data-testid={`${testIdPrefix}-confirm-phrase-input`}
            className="w-full rounded-md border border-hairline px-3 py-2 text-sm font-mono focus:outline-none focus:border-red-400"
          />
        )}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testIdPrefix}-confirm-cancel-btn`}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testIdPrefix}-confirm-submit-btn`}
            disabled={!canConfirm}
            onClick={(e) => { if (!canConfirm) { e.preventDefault(); return; } setOpen(false); onConfirm(); }}
            className="bg-red-600 text-white hover:bg-red-700 disabled:opacity-40 disabled:pointer-events-none"
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
